import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Layout, Spin, Result, ConfigProvider, theme } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import LoginButton from './components/LoginButton';
import ChatInterface from './components/ChatInterface';
import Header from './components/Header';
import './App.css';

const { Content } = Layout;

function App() {
  const { isAuthenticated, isLoading, error } = useAuth0();

  if (error) {
    return (
      <ConfigProvider
        theme={{
          algorithm: theme.defaultAlgorithm,
          token: {
            colorPrimary: '#52c41a',
            borderRadius: 8,
          },
        }}
      >
        <Layout className="app-layout">
          <Header />
          <Content className="app-content">
            <div className="centered-content">
              <Result
                icon={<ExclamationCircleOutlined />}
                title="Authentication Error"
                subTitle={error.message}
                extra={
                  <LoginButton />
                }
              />
            </div>
          </Content>
        </Layout>
      </ConfigProvider>
    );
  }

  if (isLoading) {
    return (
      <ConfigProvider
        theme={{
          algorithm: theme.defaultAlgorithm,
          token: {
            colorPrimary: '#52c41a',
            borderRadius: 8,
          },
        }}
      >
        <Layout className="app-layout">
          <Header />
          <Content className="app-content">
            <div className="centered-content">
              <Spin size="large" tip="Loading your EUDR Knowledge Agent..." />
            </div>
          </Content>
        </Layout>
      </ConfigProvider>
    );
  }

  return (
    <ConfigProvider
      theme={{
        algorithm: theme.defaultAlgorithm,
        token: {
          colorPrimary: '#52c41a',
          borderRadius: 8,
          colorBgContainer: '#ffffff',
        },
      }}
    >
      <Layout className="app-layout">
        <Header />
        <Content className="app-content">
          {isAuthenticated ? (
            <ChatInterface />
          ) : (
            <div className="centered-content">
              <LoginButton />
            </div>
          )}
        </Content>
      </Layout>
    </ConfigProvider>
  );
}

export default App;